module.exports = "https://trybtryb-legacy.web.app/img/Podcast1.2524e808.svg";